import Icon from "../../../../components/Icon";

const CashTaxLotDataMessage = () => (
  <div className="disclosures--info">
    <h4 className="disclosures--info__title">
      <Icon className="" name="system-warning" size="small" />
      Important
    </h4>
    <div className="disclosures--info__content">
      <p>
        If left blank, the Purchase date field will default to the current date.
        For Cost basis, empty fields default to 0 for equity strategies and
        quantity/par for fixed income strategies.
      </p>
    </div>
  </div>
);

export default CashTaxLotDataMessage;
